/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Formatting_Selected_EventsInputs */

const en_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear formatting of selected events`)
};

const fr_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la mise en forme des événements sélectionnés`)
};

const de_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersichtliche Formatierung ausgewählter Ereignisse`)
};

const it_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella la formattazione degli eventi selezionati`)
};

const ru_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Четкое форматирование выбранных событий`)
};

const es_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato claro de eventos seleccionados`)
};

const zh_cn2_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选事件的清晰格式`)
};

const ja_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントの書式をクリアする`)
};

const hi_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं का स्पष्ट स्वरूपण`)
};

const pt_pt2_clear_formatting_selected_events = /** @type {(inputs: Clear_Formatting_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação clara dos eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Clear formatting of selected events" |
*
* @param {Clear_Formatting_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_formatting_selected_events = /** @type {((inputs?: Clear_Formatting_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Formatting_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_clear_formatting_selected_events(inputs)
	if (locale === "de") return de_clear_formatting_selected_events(inputs)
	if (locale === "it") return it_clear_formatting_selected_events(inputs)
	if (locale === "ru") return ru_clear_formatting_selected_events(inputs)
	if (locale === "es") return es_clear_formatting_selected_events(inputs)
	if (locale === "zh-CN") return zh_cn2_clear_formatting_selected_events(inputs)
	if (locale === "ja") return ja_clear_formatting_selected_events(inputs)
	if (locale === "hi") return hi_clear_formatting_selected_events(inputs)
	if (locale === "pt-PT") return pt_pt2_clear_formatting_selected_events(inputs)
	return en_clear_formatting_selected_events(inputs)
});